import Application from './Application'
import ApplicationDependencies from './ApplicationDependencies'

export default new Application(ApplicationDependencies)
